import {styled} from '@mui/material/styles';
import theme from 'theme';

export const SpeedometersContainer = styled("div")`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    background-color: ${theme.palette.grey4};
    justify-content: flex-start;
`;